import React, { useState } from 'react';
import './ScheduleEvent.css';

import { Event, Heading } from '../../../components';
import { schedule as sessionData } from '../../../constants';
import { groupSessionsByDate } from '../../../utils';



const ScheduleEvent = () => {

  const schedule = groupSessionsByDate(sessionData); // Pass session data
  const [activeTab, setActiveTab] = useState(0); // State to manage the active tab

  return (

    <section className="schedule events">

      <Heading title={'Event Schedule'} subTitle={'Your Guide to the Event'} />

      {/* Tab Navigation */}
      <div className="tab-buttons">
        {schedule.map((day, index) => (
          <button
            key={index}
            className={`button ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {day.day} {/* Auto-generated "Day 1", "Day 2" */}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content">

        {/* Date at the top */}
        <div className="schedule-date">
          <h2>{schedule[activeTab].date}</h2>
        </div>

        <div className='event-container'>
          {/* Sessions for the Active Tab */}
          {schedule[activeTab].sessions.map(session => (
            <Event key={session.id} session={session} />
          ))}
        </div>

      </div>
    </section>

  );
};

export default ScheduleEvent;
